module.exports = __webpack_public_path__ + "img/Workflows.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Workflows.svg
// module id = 255
// module chunks = 0